import { render, staticRenderFns } from "./ShowFiles.vue?vue&type=template&id=9f83b0f6&scoped=true"
import script from "./ShowFiles.vue?vue&type=script&lang=js"
export * from "./ShowFiles.vue?vue&type=script&lang=js"
import style0 from "./ShowFiles.vue?vue&type=style&index=0&id=9f83b0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f83b0f6",
  null
  
)

export default component.exports